module.exports = __webpack_public_path__ + "static/media/dec-card-graphic@3x.d7844e7d.png";